<script>
export default {
  name: "Card"
};
</script>

<template>
  <div class="bg-white border-vectric border-4 rounded-t-2xl rounded-br-2xl ">
    <slot></slot>
  </div>
</template>

<style scoped></style>
